<template>
    <div class="w-100">
      <div class="border border-active rounded-1 px-3 py-2 w-100" :class="{'error': validateError}">
          <div class="sub-title mb-0" v-if="subLabel">
            <span>{{ subLabel }}</span>
            <span v-if="internalSelectedOptions.length > 0"> ({{ internalSelectedOptions.length }} {{ $t('components.create-template.packageSelected') }}).</span>
          </div>
          <el-checkbox-group v-model="internalSelectedOptions" @change="handleChange">
            <el-checkbox
              v-for="option in options"
              :key="option.value"
              :label="option.value"
              :disabled="option.disabled"
            >
              <el-tooltip v-if="option.disabled" :content="disabledInfo">
                <span class="text-capitalize">{{ option.label }}</span>
              </el-tooltip>
              <span v-else class="text-capitalize">{{ option.label }}</span>
            </el-checkbox>
          </el-checkbox-group>
      </div>
      <div class="sub-title text-danger my-1" v-if="validateError">
        {{ $t('error.vuelidate.required') }}
      </div>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { ElCheckboxGroup, ElCheckbox } from 'element-plus';
import type { CheckboxValueType } from 'element-plus'; // Import type CheckboxValueType

interface CheckboxOption {
  label: string;
  value: string | number;
  disabled?: boolean;
}

const props = defineProps({
  options: {
    type: Array as () => CheckboxOption[],
    required: true,
    default: () => [],
  },
  modelValue: {
    type: Array as () => number[],
    default: () => [],
  },
  subLabel: {
    type: String,
    default: () => "Add text here...",
  },
  disabledInfo: {
    type: String,
    default: () => "Item is disabled",
  },
  validateError: {
    type: Boolean,
    default: () => false,
  }
});

const emit = defineEmits<{
  'update:modelValue': [value: number[]];
  'change': [value: number[]];
}>();

const internalSelectedOptions = ref<number[]>(props.modelValue);

watch(
  () => props.modelValue,
  (newValue) => {
    internalSelectedOptions.value = newValue;
  },
  { deep: true }
);

const handleChange = (newValue: CheckboxValueType[]) => {
  const numbersOnly = newValue.filter((item): item is number => typeof item === 'number');

  emit('update:modelValue', numbersOnly);
  emit('change', numbersOnly);
};
</script>

<style scoped>
  .sub-title {
    font-size: 12px;
    line-height: 16px;
    color: rgba(0, 0, 0, 0.67);
    margin-bottom: 10px;
  }
  .border-active:hover {
    border-color: black !important;
  }
  .border-active.error {
    border-color: #f56c6c !important;
  }
</style>